import { axiosInstance, baseURL } from './AxiosClient';

export const loginService = async (data) => {
  const resp = await axiosInstance.post(`${baseURL}/admins/login`, data);
  return resp;
};
